<template>
  <div class="box">
    <router-view></router-view>
  </div>
</template>



<script>
import "animate.css";
export default {
  data() {
    return {
    };
  },
  methods: {
  },
  created() { },
  mounted() { },
};
</script>

<style>
body {
  font-size: 16px;
  color: #fff;
  /* 使用calc()函数和vw单位计算字体大小，其中1rem等于16px */
}

.borderbtngradient {
  border-bottom: 2px solid;
  /* background:linear-gradient(90deg,#26696c 10%, #00ffff 80%,#26696c);  */
  border-image: -webkit-linear-gradient(90deg, transparent, rgba(48, 160, 255, .5) 50%, transparent) 1;

  border-image: linear-gradient(to right, #26696c 10%, #00ffff 60%, #26696c) 1;
}
.amap-logo,.amap-copyright{

display:none !important;

} 
</style>